import {STEPS} from 'desktop/pages/checkout/constants/checkout';
import {ApplicationStoreType} from 'desktop/store';

import {StatusItemType, StatusType} from 'desktop/types/statusType';

import {MODULE_KEY_CHECKOUT} from '../constants';

/**
 * Get checkout current step
 * @param {ApplicationStoreType} store - current store
 * @return {STEPS} - name current step
 */
export const getCurrentStep = (store: ApplicationStoreType): STEPS =>
    store[MODULE_KEY_CHECKOUT].currentStep;

/**
 * Get all steps statuses
 * @param {ApplicationStoreType} store - current store
 * @return {StatusType} - step status
 */
export const getAllStepsStatuses = (store: ApplicationStoreType): StatusType =>
    store[MODULE_KEY_CHECKOUT].status;

/**
 * Get step status
 * @param {ApplicationStoreType} store - current store
 * @param {string} step - name step
 * @return {StatusItemType} - step status
 */
export const getStepStatus = (store: ApplicationStoreType, step: STEPS): StatusItemType =>
    store[MODULE_KEY_CHECKOUT].status[step];
